// extracted by mini-css-extract-plugin
module.exports = {"skeleton-record-list":"activityList2_skeleton-record-list__DXAnr","record-list":"activityList2_record-list__Ls21L","record-item":"activityList2_record-item__w_WJ_"};